import * as Config from '../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import Content from '../../../common/Content';
import SubMenu from '../../../common/SubMenu';
import AutomixStandAloneButton from '../../../automix/AutomixStandAloneButton';
import ListV2 from '../../../content/list/ListV2';
// import GridCharts from '../../../content/grid/GridCharts';
import ListColumns from '../../../content/list/ListColumns';
import TrendsV2 from '../../../trends/TrendsV2';

import usePageScroll from '../../../../../hooks/usePageScroll';

function ConnectedDiscoverManager({ dimension }) {
  const { width, height } = dimension;
  let { url } = useRouteMatch();
  // const isReady = (width > 1000);
  let { onScroll } = usePageScroll();

  return (
    <>
      <div className={`discover-page`} style={{ height }} onScroll={onScroll}>
        <Content name={`Discover`} isSticky={true} 
          stickyClassName={`sticky-menu-discover`}
          contentClassName={`content-discover`}
          styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
          subContent={(
            <div className='flexRow'>
              <div className={`flexRow slider-menu global-menu`}>
                <SubMenu to={`/home/trending`} or={`${url}`} label={`Trending`} />
                <SubMenu to={`/home/top-100`} label={`Top 100`} />
              </div>
              {/* {<RadioButton className={'discover-radio-button'} />} */}
            </div>
          )}
        >
          <Switch>
            <Route exact path={[`/`, `/home`, `/home/trending`]}>
              <div id={`onboarding-start`} style={{ position: `relative`}}>
                <ListColumns
                  title={'Top 10'}
                  pathApi={`/catalog/tracks/top/100/?enabled=true&is_hype=false`}
                  id={`{A}listC-top100`}
                  width={width}
                  height={(Config.LIST_ROW_HEIGHT * 5)}
                  size={Config.LIST_ROW_HEIGHT}
                  columnCount={2}
                  rowCount={5}
                  rowType={`Column`}
                  hasPagination={false} allTo={`/top-100`} allLabel={`View Top 100`}
                  enableArrows={true}
                  style={{marginTop: -20}}
                />
              </div>
              <AutomixStandAloneButton pathApi={`/catalog/tracks/top/100/?enabled=true&per_page=100`} uid={`Global Top 100`} from={`${url}/top100`} className={`discover-automix-button`} isShow={true} />
              {/* {isReady ? (
                <>
                  <GridCharts title={`VIP Crates`} id={`{B}beatsource_vip_crates_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/vip-crates`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=42992` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Monthly Top Picks`} id={`{C}beatsource_monthly_top_picks_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={false} allTo={`/bs/monthly-top-picks`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=47907` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Beatsource Flagship`} id={`{D}beatsource_flagship_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={false}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48295` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`100%`} id={`{E}beatsource_100%_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/100P`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=47908` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Club Sets`} id={`{F}beatsource_club_sets_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/club-sets`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48298` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Produced By`} id={`{G}beatsource_produced_by_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/produced-by`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=47910` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Learn To Mix`} id={`{H}beatsource_learn_to_mix_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/learn-to-mix`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48301` }
                    className={`grid-chart beatx`}
                  />
                  <GridCharts title={`Samples Series`} id={`{I}beatsource_samples_series_slice`}
                    width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                    hasPagination={true} allTo={`/bs/samples-series`}
                    arrowLeftStyle={{ display:'none', position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ display:'none', position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                    pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=47911` }
                    className={`grid-chart beatx`}
                  />
                </>
              ) : null} */}
              <TrendsV2
                pathApi={`/catalog/tracks/top/100/?enabled=true&per_page=100`}
                width={width}
                params={[ 
                  {
                    id: `global-artists`, type: 'artists', title: `Trending Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
                    grid: {
                      rowWidth: 135, //112
                      rowHeight: 165, //145,
                      rowPadding: 4,
                      coverBorder: 4,
                      gap: 8,
                      hasPagination: true,
                      blockClassName: 'card-artist',
                      coverClassName: 'cover-artist',
                    }
                  }, {
                    id: `global-labels`, type: 'labels', title: `Trending Labels`, props: [`release|label`], format: `formattedLabel`, isRandom: true, isRanked: false,
                    grid: {
                      rowWidth: 135, //112,
                      rowHeight: 168, //158 //138,
                      rowPadding: 8,
                      coverBorder: 0,
                      gap: 8,
                      hasPagination: true,
                      blockClassName: 'card-label',
                      coverClassName: 'cover-label',
                    }
                  }, {
                    id: `genres`, type: 'genres', title: `Trending Genres`, props: [`genre`], format: `formattedGenre`, isRandom: false, isRanked: false, limit: 10,
                    grid: {
                      rowWidth: 100,
                      rowHeight: 40,
                      gap: 12,
                      hasPagination: false,
                      showAll: true,
                      className: 'grid-list-genres',
                    }
                  }
                ]}
              />
            </Route>
            <Route exact path={[`/top-100`, `${url}/top-100`]}>
              <ListV2
                titleClassName={'brand-primary'}
                subTitleClassName={'type-light'}
                subTitle={` Top 100`}
                titleContainerClassName={`title-border-bottom`}
                pathApi={`/catalog/tracks/top/100/?enabled=true&is_hype=false&per_page=100`}
                sortable={false}
                id={`top100`}
                width={width}
                height={height - Config.STICKY_HEADER_HEIGHT}
                size={Config.LIST_ROW_HEIGHT}
                style={{marginTop: 85}}
                filtersStyle={{position: `absolute`, top: 20, right: 127}}
                panelStyle={{ margin: `0px 0px 16px 0px` }}
                isLoadMore={false}
                type={`Full#`}
                orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
                filters={[`track_name`, `mix_name`, `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
                isBoost={true}
                automix={true}
                automixName={`Global Top 100`}
                automixStyle={{ position: `absolute`, top: 21, left: `auto`, right: 0 }}
                enableShortcuts={true}
                from={`${url}/top-100`}
              />
            </Route>
          </Switch>
        </Content>
      </div>
    </>
  );
}

ConnectedDiscoverManager.propTypes = {
  style: PropTypes.object
}

const DiscoverManager = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedDiscoverManager);

export default DiscoverManager;
